import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericDD } from 'src/app/model/generic-data';
import { environment } from 'src/environments/environment';
import { CreateMission, MissionDto, UpdateMission } from '../gestione-missioni/missioni-dto';
import { MissioneEsplorativaLocationFields, MissioniEsplorativeFilters } from './missioni-esplorative-dto';

@Injectable({
  providedIn: 'root'
})
export class MissioniEsplorativeService {

  private missionsUrl = `${environment.apiUrl}/missions`;
  private missionFiltersUrl = `${environment.apiUrl}/missions/filters`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<Array<MissionDto & MissioneEsplorativaLocationFields>> {
    return this.http.get<Array<MissionDto & MissioneEsplorativaLocationFields>>(`${this.missionsUrl}/type/true`);
  }

  getLocationOptions(): Observable<GenericDD[]> {
    return this.http.get<GenericDD[]>(`${this.missionFiltersUrl}/locations`);
  }

  getTypeOptions(): Observable<GenericDD[]> {
    return this.http.get<GenericDD[]>(`${this.missionFiltersUrl}/types`);
  }

  getPoiOptions(): Observable<GenericDD[]> {
    return this.http.get<GenericDD[]>(`${this.missionFiltersUrl}/pois`);
  }

  search(filters: MissioniEsplorativeFilters): Observable<Array<MissionDto & MissioneEsplorativaLocationFields>> {
    const params = new HttpParams({
      fromObject: {
        location: filters.location?.trim() || ' ',
        type: filters.type?.trim() || ' ',
        poi: filters.poi?.trim() || ' '
      }
    });

    return this.http.get<Array<MissionDto & MissioneEsplorativaLocationFields>>(this.missionsUrl, { params });
  }

  create(data: CreateMission & MissioneEsplorativaLocationFields): Observable<MissionDto & MissioneEsplorativaLocationFields> {
    return this.http.post<MissionDto & MissioneEsplorativaLocationFields>(`${this.missionsUrl}`, data);
  }

  read(id: string): Observable<MissionDto & MissioneEsplorativaLocationFields> {
    return this.http.get<MissionDto & MissioneEsplorativaLocationFields>(`${this.missionsUrl}/${id}`);
  }

  update(id: string, data: UpdateMission & MissioneEsplorativaLocationFields): Observable<MissionDto & MissioneEsplorativaLocationFields> {
    return this.http.put<MissionDto & MissioneEsplorativaLocationFields>(`${this.missionsUrl}/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.missionsUrl}/${id}`);
  }
}
